import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <FaqSection />

        <MediaSection />

        <FeaturesSection />

        <AboutSection />

        <AppSection />

        <CommentsSection />

        <ContactSection />

        <TopicsSection />

        <CardsSection />

        <CarouselSection />

        <RankingSection />

        <UpdatesSection />

        <IndexSection />
      </main>

      <Footer />
    </div>
  );
}